<template>
  <router-view />
</template>

<style lang="scss">
@font-face {
  font-family: "UAF Sans";
  src: local("UAF Sans"),
    url(@/assets/fonts/UAF_Sans/UAFSans-Regular.ttf) format("truetype");
  font-display: swap;
}

@font-face {
  font-family: "UAF Sans Bold";
  src: local("UAF Sans Bold"),
    url(@/assets/fonts/UAF_Sans/UAFSans-Bold.ttf) format("truetype");
  font-display: swap;
}

@font-face {
  font-family: "UAF Sans SB";
  src: local("UAF Sans SB"),
    url(@/assets/fonts/UAF_Sans/UAFSans-SemiBold.ttf) format("truetype");
  font-display: swap;
}

@font-face {
  font-family: "UAF Sans H";
  src: local("UAF Sans H"),
    url(@/assets/fonts/UAFSans-Expanded/UAFSans-ExpandedSemiBold.otf)
      format("opentype");
  font-display: swap;
}

@font-face {
  font-family: "UAF Sans HR";
  src: local("UAF Sans HR"),
    url(@/assets/fonts/UAFSans-Expanded/UAFSans-ExpandedRegular.otf)
      format("opentype");
  font-display: swap;
}

* {
  margin: 0;
  padding: 0;
  font-family: "UAF Sans", serif;
}

html {
  scroll-behavior: smooth;

  &:has(.ethos-content-block) {
    @media (max-width: 639px) {
      overflow-x: hidden;
    }
  }
}

body {
  overflow-x: hidden;
}

.container {
  max-width: 1360px;
  width: 100%;
  margin: 100px auto 0;
  padding: 0 10px;
  box-sizing: border-box;

  @media (max-width: 767px) {
    margin-top: 43px;
  }

  @media (min-width: 768px) and (max-width: 1000px) {
    max-width: 800px;
    margin-top: 50px;
  }

  @media (min-width: 1001px) {
    box-sizing: border-box;
    padding: 0 20px !important;
  }
}

p {
  @media (max-width: 767px) {
    font-size: 18px;
    line-height: 20px;
  }
}

#app {
  overflow: hidden;
}
</style>
